export enum ServiceStatus {
  NOT_INITIALIZED = "NOT_INITIALIZED",
  INITIALIZED = "INITIALIZED",
  READY = "READY",
  ERROR = "ERROR",
}
